import { render, staticRenderFns } from "./KroksIndex.vue?vue&type=template&id=62e47ff9"
import script from "./KroksIndex.vue?vue&type=script&lang=js"
export * from "./KroksIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports